// Auto-generated normalizer for table: CAR_BOOKING.TipoAprobacion
export function tipoAprobacionNormalize(row) {
  return {
    idTipoAprobacion: row.idTipoAprobacion ?? row.IdTipoAprobacion ?? row.idTipoArpobacion ?? row.IdTipoArpobacion ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}